import { PricingGrid, formatMoney } from "./components";

function Plan({ plan, periodLabel = "/mo" }) {
  const {
    seats,
    activeSeats,
    pricingModel,
    pricePerSeat,
    flatPrice,
    total,
    originalTotal,
  } = plan;
  const isPerUnit = pricingModel === "per_unit";

  return (
    <div className="px-5 pb-5 space-y-4">
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <PricingGrid
          columns={[
            { label: "Seats", value: seats ?? "—" },
            { label: "Active", value: activeSeats ?? "—" },
            isPerUnit
              ? { label: "Price/Seat", value: pricePerSeat != null ? `$${formatMoney(pricePerSeat)}` : "—" }
              : { label: "Flat Price", value: flatPrice != null ? `$${formatMoney(flatPrice)}` : "—" },
          ]}
        />
        <div className="mt-3 pt-3 border-t border-gray-100 flex items-center justify-between">
          <span className="text-xs text-gray-500">Total</span>
          <div className="flex items-center gap-2">
            {originalTotal && (
              <span className="text-xs text-gray-400 line-through">
                ${formatMoney(originalTotal)}
              </span>
            )}
            <span
              className={`text-sm font-semibold ${
                originalTotal ? "text-[#27815C]" : "text-gray-900"
              }`}
            >
              {total != null ? `$${formatMoney(total)}${periodLabel}` : "—"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Plan;
